






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ToastState } from '@pjn/core/ui/state/notification';
import Snackbar from './Snackbar.vue';

/**
 * Muestra notificaciones tipo toast a nivel aplicacion.
 * Incluye logica que si se quiere mostrar un modal cuando ya hay uno visible, primero se oculta el actual.
 */
@Component({ components: { Snackbar } })
export default class NotificationCenter extends Vue {

    /** Info de la notificacion a mostrar */
    @Prop({ default: () => ({ type: 'information', show: false }) }) notification: ToastState;

    /** Tiempo que se debe mostrar la notificacion */
    @Prop({ default: 7000 }) dismissTime: number;

    private show?: boolean = false;

    private onNotificationClose() {
        this.$emit('close');
    }

    private get twitterStyle() {
        if (!this.notification) return false;
        return this.notification.style === 'twitter';
    }

    private get duration() {
        if (this.notification.duration !== undefined) return this.notification.duration;
        return this.dismissTime;
    }

    private get color() {
        switch (this.notification.type) {
            case 'error': return 'red lighten-1';
            case 'success': return 'green lighten-1';
            case 'information': return 'blue lighten-1';
            case 'warning': return 'amber darken-4';
            default: return null;
        }
    }

    private get buttonColor() {
        switch (this.notification.type) {
            case 'error': return 'black';
            case 'success': return 'white';
            case 'information': return 'yellow accent-2';
            case 'warning': return 'black';
            default: return 'white';
        }
    }

    @Watch('notification')
    private onInfoChange(current: ToastState, old: ToastState) {
        if (this.show && this.notification.show) {
            if (current.message !== old.message || current.type !== old.type) {
                this.show = false;
                setTimeout(() => (this.show = true), 500);
            }
        } else {
            this.show = this.notification.show;
        }
    }
}
